/* Haven Print Co. free-shipping cart: animated progress, unlock moment, one-tap add-ons */
(function () {
  if (window.__hpcLoaded) return;
  window.__hpcLoaded = true;

  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var states = {};
  var CONFETTI = ['#F8AFB8', '#E58796', '#CDEBE7', '#2E7D78', '#F9DCB8', '#EFDDEB'];

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function drawer() { return document.getElementById('Cart-Drawer'); }
  function cartPage() { return document.getElementById('Cart'); }
  function drawerOpen() { var d = drawer(); return !!(d && d.classList.contains('active')); }

  /* ---------- progress bar ---------- */
  function setBar(ship, pct, animate) {
    var track = ship.querySelector('.hpc-ship__track');
    if (!track) return;
    if (!animate || reduce) { track.style.setProperty('--hpc-p', pct); return; }
    ship.classList.add('is-instant');
    track.style.setProperty('--hpc-p', ship.__from || 0);
    void track.offsetWidth;
    ship.classList.remove('is-instant');
    requestAnimationFrame(function () { track.style.setProperty('--hpc-p', pct); });
  }

  function countDown(el, from, to, currency) {
    if (!el || reduce || from == null || from === to) return;
    var start = null, dur = 650;
    el.textContent = money(from, currency);
    function step(t) {
      if (!start) start = t;
      var k = Math.min(1, (t - start) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = money(Math.round(from + (to - from) * e), currency);
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function celebrate(ship) {
    if (reduce) return;
    var box = ship.querySelector('.hpc-ship__box');
    ship.classList.remove('is-celebrating'); void ship.offsetWidth; ship.classList.add('is-celebrating');
    if (box) {
      var layer = document.createElement('span');
      layer.className = 'hpc-confetti';
      for (var i = 0; i < 20; i++) {
        var bit = document.createElement('i');
        var a = (Math.PI * 2 * i) / 20 + Math.random() * 0.4;
        var dist = 34 + Math.random() * 46;
        bit.style.setProperty('--x', Math.cos(a) * dist + 'px');
        bit.style.setProperty('--y', Math.sin(a) * dist - 18 + 'px');
        bit.style.setProperty('--r', (Math.random() * 540 - 270) + 'deg');
        bit.style.setProperty('--d', (Math.random() * 0.12) + 's');
        bit.style.setProperty('--c', CONFETTI[i % CONFETTI.length]);
        layer.appendChild(bit);
      }
      box.appendChild(layer);
      setTimeout(function () { layer.remove(); }, 1500);
    }
    setTimeout(function () { ship.classList.remove('is-celebrating'); }, 900);
  }

  /* Runs every time the theme (or we) re-render the drawer or cart page */
  function sync(scope) {
    if (!scope) return;
    var st = states[scope.id] || (states[scope.id] = { pct: null, gap: null, unlocked: null, keys: null, pending: false });

    var lineEls = scope.querySelectorAll('[data-hpc-key]');
    var keys = [];
    lineEls.forEach(function (el) {
      keys.push(el.dataset.hpcKey);
      if (st.keys && st.keys.indexOf(el.dataset.hpcKey) === -1 && !reduce) el.classList.add('hpc-line-new');
    });
    st.keys = keys;

    var ship = scope.querySelector('[data-hpc-ship]');
    if (!ship) { st.pct = 0; st.gap = null; st.unlocked = false; return; }
    var pct = +ship.dataset.pct || 0;
    var gap = +ship.dataset.gap || 0;
    var unlocked = ship.dataset.unlocked === 'true';
    var visible = scope === cartPage() || drawerOpen();

    if (st.pct === null) {
      if (visible) { ship.__from = 0; setBar(ship, pct, true); }
      else { setBar(ship, pct, false); st.pending = true; }
    } else {
      ship.__from = st.pct;
      setBar(ship, pct, visible);
      countDown(ship.querySelector('[data-hpc-gap]'), st.gap, gap, ship.dataset.currency);
      if (unlocked && st.unlocked === false) celebrate(ship);
    }
    st.pct = pct; st.gap = gap; st.unlocked = unlocked;
  }

  function watch(el) {
    if (!el || el.__hpcWatch) return;
    el.__hpcWatch = true;
    var raf;
    new MutationObserver(function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { sync(el); });
    }).observe(el, { childList: true });
    sync(el);
  }

  document.addEventListener('cart-drawer:open', function () {
    var d = drawer(); if (!d) return;
    var st = states[d.id];
    var ship = d.querySelector('[data-hpc-ship]');
    if (st && st.pending && ship) { st.pending = false; ship.__from = 0; setBar(ship, st.pct, true); }
  });

  /* ---------- adding to cart ---------- */
  function rebindDrawer(d) {
    if (typeof CartDrawer === 'undefined') return;
    try {
      var cd = Object.create(CartDrawer.prototype);
      cd.container = d;
      cd.removeProductEvent(); cd.notesToggle(); cd.termsCheckbox();
    } catch (e) { }
  }

  function renderSections(sections) {
    var parse = function (html, sel) { var n = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return n ? n.innerHTML : null; };
    var d = drawer();
    if (d && sections && sections['cart-drawer']) {
      var inner = parse(sections['cart-drawer'], '.cart-drawer');
      if (inner !== null) { d.innerHTML = inner; rebindDrawer(d); }
    }
    var toggle = document.getElementById('cart-drawer-toggle');
    if (toggle && sections && sections['cart-bubble']) {
      var count = parse(sections['cart-bubble'], '.thb-item-count');
      var target = toggle.querySelector('.thb-item-count') || toggle;
      if (count !== null) target.innerHTML = count;
    }
  }

  function addVariant(id, btn, card, done) {
    if (!id || btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    var err = card && card.querySelector('.hpc-up__error'); if (err) err.remove();
    var onCartPage = !!cartPage();

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }], sections: onCartPage ? undefined : 'cart-drawer,cart-bubble', sections_url: location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: j.items ? j.items[0] : j } }));
        if (onCartPage) { location.reload(); return; }
        btn.classList.remove('is-loading');
        var label = btn.querySelector('span'); if (label) label.textContent = 'Added';
        if (card) card.classList.add('is-added');
        if (done) done();
        setTimeout(function () { renderSections(j.sections); }, reduce ? 0 : 380);
      })
      .catch(function (e) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        var msg = (e && (e.description || e.message)) || 'Couldn’t add that. Try again.';
        var host = card || btn.parentNode;
        var p = document.createElement('span');
        p.className = 'hpc-up__error'; p.setAttribute('role', 'alert'); p.textContent = msg;
        host.appendChild(p);
      });
  }

  /* ---------- option picker ---------- */
  function swatchMap(text) {
    var map = {};
    (text || '').split(/\n/).forEach(function (line) {
      var i = line.indexOf(':'); if (i < 0) return;
      var name = line.slice(0, i).trim().toLowerCase(), val = line.slice(i + 1).trim();
      if (/^#|^rgb/i.test(val)) map[name] = val;
    });
    return map;
  }

  function closePicker(pick) {
    if (!pick || pick.hidden) return;
    pick.hidden = true;
    if (pick.__btn) { pick.__btn.setAttribute('aria-expanded', 'false'); }
    if (pick.__card) pick.__card.classList.remove('is-picking');
    pick.__card = pick.__btn = null;
  }

  function openPicker(card, btn) {
    var wrap = card.closest('[data-hpc-ups]');
    var pick = wrap && wrap.querySelector('[data-hpc-pick]');
    var json = card.querySelector('[data-hpc-json]');
    if (!pick || !json) return;
    if (pick.__card === card && !pick.hidden) { closePicker(pick); btn.focus(); return; }
    closePicker(pick);

    var data; try { data = JSON.parse(json.textContent); } catch (e) { return; }
    var currency = wrap.dataset.currency;
    var swatches = swatchMap(wrap.dataset.swatches);
    var start = data.variants.filter(function (v) { return String(v.id) === btn.dataset.variant; })[0] || data.variants[0];
    var sel = start.options.slice();

    var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
    var html = '<div class="hpc-pick__head"><span class="hpc-pick__name">' + esc(btn.dataset.title || '') + '</span>' +
      '<button type="button" class="hpc-pick__close" data-hpc-pick-close aria-label="Close options">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>';
    data.options.forEach(function (name, i) {
      var seen = {}, values = [];
      data.variants.forEach(function (v) { var val = v.options[i]; if (!seen[val]) { seen[val] = 1; values.push(val); } });
      var isColor = /colou?r/i.test(name);
      html += '<fieldset><legend>' + esc(name) + '</legend><div class="hpc-pills">';
      values.forEach(function (val) {
        var dot = isColor && swatches[val.toLowerCase()] ? '<span class="hpc-pill__dot" style="--dot:' + swatches[val.toLowerCase()] + '"></span>' : '';
        html += '<button type="button" class="hpc-pill" data-hpc-pill data-i="' + i + '" data-val="' + esc(val).replace(/"/g, '&quot;') + '" aria-pressed="false">' + dot + esc(val) + '</button>';
      });
      html += '</div></fieldset>';
    });
    html += '<button type="button" class="hpc-pick__add" data-hpc-pick-add><span></span></button>';
    pick.innerHTML = html;

    function match() {
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
    }
    function update() {
      pick.querySelectorAll('[data-hpc-pill]').forEach(function (b) {
        var i = +b.dataset.i, val = b.dataset.val;
        b.setAttribute('aria-pressed', sel[i] === val ? 'true' : 'false');
        var test = sel.slice(); test[i] = val;
        var ok = data.variants.some(function (v) { return v.available && v.options.every(function (o, k) { return o === test[k]; }); });
        b.classList.toggle('is-out', !ok);
      });
      var v = match(), add = pick.querySelector('[data-hpc-pick-add]');
      add.disabled = !(v && v.available);
      add.dataset.variant = v ? v.id : '';
      add.querySelector('span').textContent = v ? (v.available ? 'Add for ' + money(v.price, currency) : 'Sold out') : 'Unavailable';
    }
    pick.__update = update;
    pick.__sel = sel;
    pick.__card = card; pick.__btn = btn;
    update();

    pick.hidden = false;
    card.classList.add('is-picking');
    btn.setAttribute('aria-expanded', 'true');
    var first = pick.querySelector('.hpc-pill[aria-pressed="true"]') || pick.querySelector('.hpc-pill');
    if (first) first.focus({ preventScroll: true });
    if (pick.scrollIntoView) pick.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var add = t.closest && t.closest('[data-hpc-add]');
    if (add) {
      e.preventDefault();
      var card = add.closest('[data-hpc-card]');
      if (add.hasAttribute('data-hpc-choose')) openPicker(card, add);
      else addVariant(add.dataset.variant, add, card);
      return;
    }
    var pill = t.closest && t.closest('[data-hpc-pill]');
    if (pill) {
      var pick = pill.closest('[data-hpc-pick]');
      pick.__sel[+pill.dataset.i] = pill.dataset.val;
      pick.__update();
      return;
    }
    var close = t.closest && t.closest('[data-hpc-pick-close]');
    if (close) { var p = close.closest('[data-hpc-pick]'); var b = p.__btn; closePicker(p); if (b) b.focus(); return; }
    var padd = t.closest && t.closest('[data-hpc-pick-add]');
    if (padd) {
      var pk = padd.closest('[data-hpc-pick]');
      var c = pk.__card, cb = pk.__btn;
      addVariant(padd.dataset.variant, padd, c, function () {
        if (cb) { cb.disabled = true; var s = cb.querySelector('span'); if (s) s.textContent = 'Added'; }
      });
    }
  });

  function init() { watch(drawer()); watch(cartPage()); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
